import { mutationTree } from 'typed-vuex';
import { Link, Links } from '@/repositories/fo-manual-API/LinksRepository/types';
import initialState from '@/store/modules/link/state';

const mutations = mutationTree(initialState, {
  SET_LINKS(state, links: Links) {
    state = Object.assign(state, links);
  },
  SET_LINK(state, link: Link) {
    state['hydra:member'].push(link);
  },
  UPDATE_LINK(state, payload: Link) {
    const index = state['hydra:member'].indexOf(payload);
    if (index > -1) {
      state['hydra:member'][index] = payload;
    }
  },
  DELETE_LINK(state, link: Link) {
    const index = state['hydra:member'].indexOf(link);
    if (index > -1) {
      state['hydra:member'].splice(index, 1);
    }
  },
});

export default mutations;
